// extracted by mini-css-extract-plugin
export default {"online":"LastVisit_online__pyIso"};